module.exports = __webpack_public_path__ + "media/src/images/icons/actions-4632f6cf7da052c9f44c3aaccebf7e35.svg";